const regexPattern = /^.+@.+$/;

export const validateEmail = (email: string) => {

   return regexPattern.test(email);
};